import React from 'react';
import useSearch from '../../../context/search/useSearch';

interface SearchResultsContentPagesProps {
  dataSet: DOMStringMap;
}

interface MenuLink {
  title: string
  url: string
}

const SearchResultsContentPages: React.FC<SearchResultsContentPagesProps> = ({ dataSet }) => {
  const { activeTab, searchResultsPages, quickSearchTerm } = useSearch();

  // Only render if this is the active tab
  if (activeTab !== 'pages') {
    return null;
  }

  // console.log('searchResultsPages: ', searchResultsPages)

  const pages = searchResultsPages ?? []

  // Parse menu data from data attributes
  const menuLinks: MenuLink[] = dataSet.tabMenuLinks ? JSON.parse(dataSet.tabMenuLinks) : []
  const menuTitle = dataSet.tabMenuTitle || 'Get Help'

  console.log('menuLinks: ', menuLinks)

  return (
    <div className={`search search__results search__results--list search__results--pages tab ${pages.length === 0 ? 'no-results' : ''}`}>
      {/* Menu Section */}
      {menuLinks.length > 0 && (
        <div className="search__tab-menu">
          <h3 className="search__tab-menu-title">{menuTitle}</h3>
          <ul className="search__tab-menu-list">
            {menuLinks.map((link, index) => (
              <li key={index} className="search__tab-menu-item">
                <a href={link.url} className="search__tab-menu-link">
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}


      {pages.length > 0 ? (
        <div className={'search__results-list search__results-list--pages'}>
          <ul>
            {pages.map((page, index) => (
              <li className={'search__results-item search__results-item--pages'} key={index}>
                <a href={page.url} data-ticket={page.ticket ?? ''}>
                  <div className='search__results-item-type'>{page.type}</div>
                  <h5 className='search__results-item-title'>{page.title}</h5>
                  {/* <div><p>{page.description}</p></div> */} {/* this returns the whole pages html */}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="search__results-no-results">
          <p>Sorry we couldn&lsquo;t find &quot;{quickSearchTerm}&quot;</p>
          <p>Try adjusting your search or get in touch:</p>
          <div className="search__results-no-results-buttons">
            <a className="btn-b-to-w btn--large" href="/contact-us">Contact Us</a>
            <a className="btn-2 btn--secondary btn--large" href="/">Back Home</a>
          </div>
        </div>

      )}

    </div>
  );
};

export default SearchResultsContentPages;
